import { Skeleton, Stack, Typography } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';

interface Props {
  totalItems: number;
  itemsShowing?: number;
  isFetching: boolean;
}

export function TotalItemsLoader({ totalItems, itemsShowing, isFetching }: Props) {
  const t = useMyAssortmentTFunction();

  return (
    <Stack flexDirection="row" alignItems="center" gap={0.5}>
      <Typography component="span" variant="body2">
        {t('myAssortment.showing')}
      </Typography>
      {(!!itemsShowing || itemsShowing === 0) && (
        <>
          <Typography component="span" variant="body2" fontWeight={600}>
            {isFetching ? (
              <Skeleton width={40} />
            ) : totalItems < itemsShowing ? (
              totalItems
            ) : (
              itemsShowing
            )}
          </Typography>
          <Typography component="span" variant="body2">
            {t('myAssortment.of')}
          </Typography>
        </>
      )}

      <Typography component="span" variant="body2" fontWeight={600}>
        {isFetching ? <Skeleton width={40} /> : totalItems}
      </Typography>
      <Typography component="span" variant="body2">
        {t('myAssortment.items')}
      </Typography>
    </Stack>
  );
}
